import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest } from "components/Types/GeneralTypes";
import { alertService } from "components/Varios/alert_service";
import config from "config.json"
import { authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { DetalleSolicitudReplanificacion, PostSolicitudMasivo, PostSolicitudMasivoPermiso, SolicitudesPermisosPorAprobar, SolicitudesPorAprobar, SolicitudesSolCambioHorarioPRNPorAprobar, SolicitudVacacionesRechazoDTO, TipoFiltroSolicitudAprobar } from "./TypesAprobacionSolicitudes";
import ExitoSVG from "assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "assets/icons/Permisos/Error.svg"

import Swal from 'sweetalert2'

async function showAlert(message, imageSrc, isSuccess) {
    Swal.fire({
        text: message,
        imageUrl: `${imageSrc}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}


export async function ObtenerInformacionSolicitudes(tipo:TipoFiltroSolicitudAprobar) {
    const URL = config.SERVER_URL + (tipo !== undefined? `Aprobacion/${tipo}`:"Aprobacion")
    const datosUsuario: UserData = authenticationService.currentUserValue;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithUserData(datosUsuario)
            })
        if (tipo == "SOLVAC" || tipo == "TO") {
            const datos: SolicitudesPorAprobar[] | string = respuesta.data;

            if (typeof (datos) === "string") {
                resultado = { status: respuesta.status, dataResponse: datos }
            }
            else {
                const datosMapeados: SolicitudesPorAprobar[] = MapearSolicitudesPorAprobar(datos)
                resultado = { status: respuesta.status, dataResponse: datosMapeados }
            }
        } else if (tipo == "PER") {
            const datos: SolicitudesPermisosPorAprobar[] | string = respuesta.data;

            if (typeof (datos) === "string") {
                resultado = { status: respuesta.status, dataResponse: datos }
            }
            else {
                const datosMapeados: SolicitudesPermisosPorAprobar[] = MapearSolicitudesPermisosPorAprobar(datos)
                resultado = { status: respuesta.status, dataResponse: datosMapeados }
            }
        } else if (tipo == "SOLCAM") {
            const datos: SolicitudesSolCambioHorarioPRNPorAprobar[] | string = respuesta.data;

            if (typeof (datos) === "string") {
                resultado = { status: respuesta.status, dataResponse: datos }
            }
            else {
                const datosMapeados: SolicitudesSolCambioHorarioPRNPorAprobar[] = MapearSolicitudesCambioHorarioPRNPorAprobar(datos)
                resultado = { status: respuesta.status, dataResponse: datosMapeados }
            }
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return resultado;
}

export function MapearSolicitudesPorAprobar(datos: SolicitudesPorAprobar[]) {
    const datosMapeados: SolicitudesPorAprobar[] = datos.map((val, ind) => {
        return {
            ...val,


            acciones: {
                estado: val.estado,
                tiposolicitud: val.tipoSolicitud,
                idSolicitud: val.idSolicitud,
                aprueba: val.aprueba,
                apruebanAmbos: val.apruebanAmbos,
                cantidadAprueba: val.cantidadAprueba,
                diaOrdinario: val.diaOrdinario,
                fechaDesde: val.fechaDesde,
                fechaHasta: val.fechaHasta,
                horaDesde: val.horaDesde,
                horaHasta: val.horaHasta,
                horasTotal: val.horasTotal,
                nombres: val.nombres,
                estadoParse: val.estadoParse,
                observacion: val.observacion,
                estadoString: val.estadoString,
                fechaReintegro: val.fechaReintegro,
                fechaSolicitud: val.fechaSolicitud,
                diasPendientes: val.diasPendientesVacaciones,
                nuevoSaldo: val.diasRestantesVacaciones,
                permisoCargoVacaciones: val.permisoCargoVacaciones


            }
        }
    })
    return datosMapeados
}

export function MapearSolicitudesPermisosPorAprobar(datos: SolicitudesPermisosPorAprobar[]) {
    const datosMapeados: SolicitudesPermisosPorAprobar[] = datos.map((val, ind) => {
        return {
            ...val,
            acciones: {
                idPermiso: val.idPermiso,
                idPersona: val.idPersona,
                fechaSolicitud: val.fechaSolicitud,
                fechaInicio: val.fechaInicio,
                fechaFin: val.fechaFin,
                horaInicio: val.horaInicio,
                horaFin: val.horaFin,
                nombres: val.nombres,
                aprueba: val.aprueba,
                refArchivo1: val.refArchivo1,
                tipoPermiso: val.tipoPermiso,
                tiempo: val.tiempo,
                doctor: val.doctor,
                idTipoPermiso: val.idTipoPermiso,
                refArchivoInforme: val.refArchivoInforme,
                estadoPermiso: val.estadoPermiso,
                horasDif: val.horasDif,
                estadoParse: val.estadoParse
            }
        }
    })
    return datosMapeados
}

export function MapearSolicitudesCambioHorarioPRNPorAprobar(datos: SolicitudesSolCambioHorarioPRNPorAprobar[]) {
    const datosMapeados: SolicitudesSolCambioHorarioPRNPorAprobar[] = datos.map((val, ind) => {
        return {
            ...val,
            acciones: {
                idSolCambioHorarioPRN: val.idSolCambioHorarioPRN,
                idPersona: val.idPersona,
                fechaSolicitud: val.fechaSolicitud,
                fechaDesde: val.fechaDesde,
                fechaHasta: val.fechaHasta,
                horaEntrada: val.horaEntrada,
                horaSalida: val.horaSalida,
                nombres: val.nombres,
                aprueba: val.aprueba,
                refArchivo: val.refArchivo,
                estadoSolicitud: val.estadoSolicitud,
                observacion: val.observacion,
                estadoParse: val.estadoParse,
            }
        }
    })
    return datosMapeados
}


export async function AprobarParcialmenteSolicitudVacaciones(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = config.SERVER_URL + "SolicitudVacaciones/DirectivoAprobador/AprobarParcialmente/" + idSolicitud;
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        //alertService.success("Se ha aprobado la solicitud de vacaciones");
        showAlert("Se ha aprobado la solicitud de vacaciones", ExitoSVG, true);
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            //alertService.error(error.response.data);
            showAlert(error.response.data, ErrorSVG, false);
        }
        return -1;
    }



}

export async function AprobarParcialmenteSolicitudPermisos(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = config.SERVER_URL + "SolicitudPermisos/DirectivoAprobador/AprobarParcialmente/" + idSolicitud;
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        //alertService.success("Se ha aprobado la solicitud de permiso y/o licencia");
        showAlert("Se ha aprobado la solicitud de permiso y/o licencia", ExitoSVG, true);
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            //alertService.error(error.response.data);
            showAlert(error.response.data, ErrorSVG, false);
        }
        return -1;
    }



}

export async function AprobarSolicitudVacaciones(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudVacaciones/DirectivoAprobador/Aprobar/" + idSolicitud;
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        //alertService.success("Se ha aprobado la solicitud de vacaciones");
        showAlert("Se ha aprobado la solicitud de vacaciones", ExitoSVG, true);
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            //alertService.error(error.response.data);
            showAlert(error.response.data, ErrorSVG, false);
        }
        return -1;
    }



}

export async function AprobarSolicitudPermisos(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudPermisos/DirectivoAprobador/Aprobar/" + idSolicitud;
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        //alertService.success("Se ha aprobado la solicitud de permiso y/o licencia");
        showAlert("Se ha aprobado la solicitud de permiso y/o licencia", ExitoSVG, true);
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            //alertService.error(error.response.data);
            showAlert(error.response.data, ErrorSVG, false);
        }
        return -1;
    }



}

export async function RechazarSolicitudVacaciones(idSolicitud: number, datosRechazar: SolicitudVacacionesRechazoDTO) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudVacaciones/DirectivoAprobador/Rechazar/" + idSolicitud;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.post(URL, datosRechazar,
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        resultado = { status: respuesta.status, dataResponse: respuesta.data }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }

    return resultado;



}

export async function RechazarSolicitudPermisos(idSolicitud: number, datosRechazar: SolicitudVacacionesRechazoDTO) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudPermisos/DirectivoAprobador/Rechazar/" + idSolicitud;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.post(URL, datosRechazar,
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        resultado = { status: respuesta.status, dataResponse: respuesta.data }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }

    return resultado;
}

export async function AprobarAnulacionVacaciones(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudVacaciones/DirectivoAprobador/Anular/" + idSolicitud;
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        //alertService.success("Se ha anulado la solicitud");
        showAlert("Se ha anulado la solicitud", ExitoSVG, true);
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            //alertService.error(error.response.data);
            showAlert(error.response.data, ErrorSVG, false);
            return -1;
        }

    }
}


export async function AprobarParcialmenteReplanificacionVacaciones(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = config.SERVER_URL + "SolicitudReplanificacionVacaciones/DirectivoAprobador/AprobacionParcial/" + idSolicitud;
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        //alertService.success("Se ha aprobado la solicitud de reprogramación y/o justificación de vacaciones");
        showAlert("Se ha aprobado la solicitud de reprogramación y/o justificación de vacaciones", ExitoSVG, true);
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            //alertService.error(error.response.data);
            showAlert(error.response.data, ErrorSVG, false);
        }
        return -1;
    }
}

export async function AprobarReplanificacionVacaciones(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudReplanificacionVacaciones/DirectivoAprobador/Aprobacion/" + idSolicitud;
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        //alertService.success("Se ha aprobado la solicitud de reprogramación y/o justificación de vacaciones");
        showAlert("Se ha aprobado la solicitud de reprogramación y/o justificación de vacaciones", ExitoSVG, true);
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            //alertService.error(error.response.data);
            showAlert(error.response.data, ErrorSVG, false);
            return -1;
        }

    }
}



export async function AprobarMasivaSolicitudVacaciones(listadoSolicitudes:SolicitudesPorAprobar[]){
    
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudVacaciones/DirectivoAprobador/Aprobar/Masiva" ;

    const listadoIdSolicitudes:PostSolicitudMasivo[] = listadoSolicitudes.map((s,i) => {
        return {
            tipo:s.tipoSolicitud,
            aprueba:s.aprueba,
            idsolicitud:s.idSolicitud
        }
    })
    try {
        const respuesta = await axios.post(URL, {listadoSolicitudes:listadoIdSolicitudes},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )

        const respuestaAprobacionMasiva:string[] = respuesta.data;
        
        if(respuestaAprobacionMasiva.length > 0){
            const mensajesProblemas = respuestaAprobacionMasiva.map((mensaje,indimensaje) => {
                return mensaje +"\n";
            })

            alertService.error(mensajesProblemas);
        }
        else{
            //alertService.success("Todas las solicitudes fueron aprobadas.");
            showAlert("Todas las solicitudes fueron aprobadas.", ExitoSVG, true);
        }

        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            //alertService.error(error.response.data);
            showAlert(error.response.data, ErrorSVG, false);
            return -1;
        }

    }
}

export async function AprobarMasivaSolicitudPermisos(listadoSolicitudes: SolicitudesPermisosPorAprobar[]) {

    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudPermisos/DirectivoAprobador/Aprobar/Masiva";

    const listadoIdSolicitudes: PostSolicitudMasivoPermiso[] = listadoSolicitudes.map((s, i) => {
        return {
            tipo: s.idTipoPermiso,
            aprueba: s.aprueba,
            idsolicitud: s.idPermiso
        }
    })
    try {
        const respuesta = await axios.post(URL, { listadoSolicitudes: listadoIdSolicitudes },
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )

        const respuestaAprobacionMasiva: string[] = respuesta.data;

        if (respuestaAprobacionMasiva.length > 0) {
            const mensajesProblemas = respuestaAprobacionMasiva.map((mensaje, indimensaje) => {
                return mensaje + "\n";
            })

            alertService.error(mensajesProblemas);
        }
        else {
            //alertService.success("Todas las solicitudes fueron aprobadas.");
            showAlert("Todas las solicitudes fueron aprobadas.", ExitoSVG, true);
        }

        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            //alertService.error(error.response.data);
            showAlert(error.response.data, ErrorSVG, false);
            return -1;
        }

    }
}

export async function RechazarSolicitudAnulacionVacaciones(idSolicitud: number, datosRechazar: SolicitudVacacionesRechazoDTO) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudVacaciones/DirectivoAprobador/RechazarAnular/" + idSolicitud;
    var resultado: ResponseRequest = { status: -1 }

    try {
        const respuesta = await axios.post(URL, datosRechazar,
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        resultado = { status: respuesta.status, dataResponse: respuesta.data }

        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }

        }
    }

    return resultado;

}

export async function RechazarSolicitudReplanificacionVacaciones(idSolicitud: number, datosRechazar: SolicitudVacacionesRechazoDTO) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudReplanificacionVacaciones/DirectivoAprobador/Negacion/" + idSolicitud;
    var resultado: ResponseRequest = { status: -1 }

    try {
        const respuesta = await axios.post(URL, datosRechazar,
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        resultado = { status: respuesta.status, dataResponse: respuesta.data }

        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }

        }
    }

    return resultado;

}

export async function RechazarSolicitudReintegroVacaciones(idSolicitud: number, datosRechazar: SolicitudVacacionesRechazoDTO) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudVacaciones/DirectivoAprobador/RechazarReintegro/" + idSolicitud;
    var resultado: ResponseRequest = { status: -1 }

    try {
        const respuesta = await axios.post(URL, datosRechazar,
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        resultado = { status: respuesta.status, dataResponse: respuesta.data }

        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }

        }
    }

    return resultado;

}

export async function AprobarReintegroVacaciones(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudVacaciones/DirectivoAprobador/AprobarReintegro/" + idSolicitud;
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        //alertService.success("Se ha aprobado la solicitud de reintegro de vacaciones");
        showAlert("Se ha aprobado la solicitud de reintegro de vacaciones", ExitoSVG, true);
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            alertService.error(error.response.data);
            showAlert(error.response.data, ErrorSVG, false);
            return -1;
        }

    }




}

export async function DirectivoAprobadorObtenerVistaPreviaFormularioVacaciones(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL = config.SERVER_URL + "SolicitudVacaciones/DirectivoAprobador/VistaPreviaFormularioSolicitud/" + idSolicitud;
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )
        let url = window.URL.createObjectURL(respuesta.data);
        respuestaResponse = { status: respuesta.status, dataResponse: url }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }

    return respuestaResponse


}

export async function DirectivoAprobadorObtenerVistaPreviaFormularioPermisos(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL = config.SERVER_URL + "SolicitudPermisos/DirectivoAprobador/VistaPreviaFormularioSolicitud/" + idSolicitud;
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )
        let url = window.URL.createObjectURL(respuesta.data);
        respuestaResponse = { status: respuesta.status, dataResponse: url }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }

    return respuestaResponse


}

export async function DirectivoAprobadorObtenerVistaPreviaFormularioAnulacionVacaciones(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL = config.SERVER_URL + "SolicitudVacaciones/DirectivoAprobador/VistaPreviaFormularioSolicitudAnulacion/" + idSolicitud;
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )
        let url = window.URL.createObjectURL(respuesta.data);
        respuestaResponse = { status: respuesta.status, dataResponse: url }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }

    return respuestaResponse


}


export async function DirectivoAprobadorObtenerVistaPreviaFormularioReintegroVacaciones(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL = config.SERVER_URL + "SolicitudVacaciones/DirectivoAprobador/VistaPreviaFormularioSolicitudrReintegro/" + idSolicitud;
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )
        let url = window.URL.createObjectURL(respuesta.data);
        respuestaResponse = { status: respuesta.status, dataResponse: url }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }

    return respuestaResponse


}


export async function DirectivoAprobadorObtenerVistaPreviaFormularioReplanificacionVacaciones(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL = config.SERVER_URL + "SolicitudReplanificacionVacaciones/DirectivoAprobador/Formulario/" + idSolicitud;
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )
        let url = window.URL.createObjectURL(respuesta.data);
        respuestaResponse = { status: respuesta.status, dataResponse: url }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }

    return respuestaResponse


}

export async function ObtenerDetalleSolicitudReplanificacion(idSolicitud:number,tipo:"reprogramacion"|"reintegro" = "reprogramacion"){
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL = config.SERVER_URL + `SolicitudReplanificacionVacaciones/Detalle/${tipo}/${idSolicitud}` ;
    try {
        const respuesta = await axios.get(URL, 
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )

        const informacion:DetalleSolicitudReplanificacion|null = respuesta.data
        respuestaResponse.status = 200;
        respuestaResponse.dataResponse = informacion;
            
    } catch (error) {
        respuestaResponse.status = -1;

        if (axios.isAxiosError(error) && error.response) {

            respuestaResponse.status = error.response.status;
            respuestaResponse.errorMessage = error.response.data;

        }

    }

    return respuestaResponse
}

export async function AprobarParcialmenteSolicitudCambioHorario(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = config.SERVER_URL + "SolicitudCambioHorarioPRN/DirectivoAprobador/AprobarParcialmente/" + idSolicitud;
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        //alertService.success("Se ha aprobado la solicitud de cambio de horario de permiso para cuidado del recién nacido");
        showAlert("Se ha aprobado la solicitud de cambio de horario de permiso para cuidado del recién nacido", ExitoSVG, true);
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            //alertService.error(error.response.data);
            showAlert(error.response.data, ErrorSVG, false);
        }
        return -1;
    }



}

export async function RechazarSolicitudCambioHorario(idSolicitud: number, datosRechazar: SolicitudVacacionesRechazoDTO) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudCambioHorarioPRN/DirectivoAprobador/Rechazar/" + idSolicitud;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.post(URL, datosRechazar,
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        resultado = { status: respuesta.status, dataResponse: respuesta.data }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }

    return resultado;
}

export async function DirectivoAprobadorObtenerVistaPreviaFormularioCambioHorario(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL = config.SERVER_URL + "SolicitudCambioHorarioPRN/DirectivoAprobador/VistaPreviaFormularioSolicitud/" + idSolicitud;
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )
        let url = window.URL.createObjectURL(respuesta.data);
        respuestaResponse = { status: respuesta.status, dataResponse: url }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }

    return respuestaResponse


}

export async function AprobarSolicitudCambioHorario(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const URL = config.SERVER_URL + "SolicitudCambioHorarioPRN/DirectivoAprobador/Aprobar/" + idSolicitud;
    try {
        const respuesta = await axios.post(URL, {},
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        //alertService.success("Se ha aprobado la solicitud de permiso y/o licencia");
        showAlert("Se ha aprobado la solicitud de cambio de horario de permiso para cuidado del recién nacido", ExitoSVG, true);
        return 1;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            //alertService.error(error.response.data);
            showAlert(error.response.data, ErrorSVG, true);
        }
        return -1;
    }



}





